import { Box, Button, Grid, Skeleton, Theme, Typography, useTheme, useMediaQuery, SelectChangeEvent } from "@mui/material";
import { FrequencyArray, Frequencytype, InvestmentFundType } from "../../../redux-store/types/api-types";
import { MandateCreation, MandateListItem, MandatesListResBody } from "../../../redux-store/types/investorProfile";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { MpowerValidationType } from "../types";
import { CustomeBlueDatePicker, CustomeBlueDropDown, CustomeOrangeDropDown, CustomeNumberInput, PickUpInput } from "./FromInput";
import AddBankModal from "../common/AddBankModal";
import dayjs from "dayjs";
import { WEEKLYDAYS } from "../../../utils/constant";
import { FormikValues, useFormikContext } from "formik";
import {
    BankDetails, GetOrderEntryBanksListResponseBody
} from "../../../redux-store/types/orderManagement";
import { MandateInfoBox, MandateSelectionDialog } from "./Mandate";
import MFCheckbox from "../../../lib/formik/Checkbox";
import { SAVING_MANDATE_SUCCESS } from "../../../redux-store/types/mandate";
import { useDispatch, useSelector } from "react-redux";
import { getMandatesList } from "../../../redux-store/actions/investorProfile";
import { RootStateType } from "../../../redux-store/reducers";
import { useRefDebounce } from "../../../utils/useDebounce";
import { findNextValidDate } from "../../../utils/utilityFunctions";

interface SIPProps {
    isLoading: boolean;
    id: string | number
    // validation: ValidationInvestment
    clientCode?: string
    activeMandateList: Array<MandateListItem>
    data: InvestmentFundType
    valueIdentifier: string
    isSubmitting: boolean;
    bankAccountList?: GetOrderEntryBanksListResponseBody;
    mandatesListRes?: MandatesListResBody;
    isComingFromIndFund?: boolean
    banksList?: Array<MandateCreation>
}

export const handleDateValidation = (ArrayOfDate: Array<string | number>, date: dayjs.Dayjs, firstOrderFlag = false, frequency = "MONTHLY") => {
    const today = dayjs().startOf("day");

    // const isWeekend = date.day() === 0 || date.day() === 6;
    // if (isWeekend) {
    //     return true;  // DISABLE weekends
    // }

    if (firstOrderFlag) {
        let cutoffDate: dayjs.Dayjs;

        switch (frequency) {
            case 'DAILY':
                cutoffDate = today.add(2, 'day');
                break;
            case 'WEEKLY':
                cutoffDate = today.add(7, 'day');
                break;
            case 'MONTHLY':
                cutoffDate = today.add(30, 'day');
                break;
            case 'QUARTERLY':
                cutoffDate = today.add(90, 'day');
                break;
            default:
                cutoffDate = today.add(30, 'day');
        }

        // If before cutoff → disable all dates
        if (date.isBefore(cutoffDate, 'day')) {
            return true;
        }
    }

    if (ArrayOfDate?.length === 0) {
        return false
    }
    if (typeof ArrayOfDate?.[0] === 'number') {
        return !ArrayOfDate?.includes(dayjs(date).date());
    }

    if (typeof ArrayOfDate?.[0] === 'string') {
        const capitalizedDays = ArrayOfDate.map(day =>
            day.toString().charAt(0) + day.toString().slice(1).toLowerCase()
        );
        const day = capitalizedDays.map(item => WEEKLYDAYS.indexOf(item))
        return !day?.includes(dayjs(date).day());
        // Saturday/Sunday are handled here if they’re in the list (indexes 6 and 0 respectively)
        // const allowedWeekdayIndexes = capitalizedDays.map(name => WEEKLYDAYS.indexOf(name));
        // return !allowedWeekdayIndexes.includes(dayjs(date).day());
    }
    return false
}



const Sip = (props: SIPProps) => {
    const { isLoading, id, data, clientCode, activeMandateList, valueIdentifier, isSubmitting, bankAccountList, mandatesListRes, banksList } = props;
    const { palette } = useTheme();
    const dispatch = useDispatch();
    const history = useHistory();
    const { validataion: validation, folios, frequencies = [], sipAllowed = "Y", sip } = data
    const { pathname } = history.location
    const [activeMandateCount, setActiveMandateCount] = useState<boolean>(false);
    const { iwappRmId = "", clientInterfaceCode } = useSelector((store: RootStateType) => store.id)


    const { values, setFieldValue, errors, setValues } = useFormikContext<FormikValues>();
    const [isMandateLoading, setIsMandateLoading] = useState<boolean>(false);
    const { selectedPortfolio } = useSelector((store: RootStateType) => store.selectedPortfiolio);
    const [activeMandList, setActiveMandList] = useState<Array<MandateListItem>>([]);
    const debounce = useRefDebounce(100);

    const [isMandateSelectDialogOpen, setMandateSelectDialogOpen] = useState<boolean>(false);
    const isXs = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    const mandateDialogOptions = [
        {
            id: 0,
            label: isXs ? 'Create' : 'Create New Mandate',
            value: 'createNewMandate'
        },
        {
            id: 1,
            label: isXs ? 'Active' : 'Active Mandates',
            value: 'approvedMandates'
        },
    ];
    const [curMandateOption, setCurMandateOption] = useState<number>(mandateDialogOptions[0].id);
    const [openBankModal, setOpenBankModal] = useState(false);


    const getArrayFrequency = data?.frequencies?.filter((item: FrequencyArray) => item?.transactionType === "SIP" && item?.frequency)
    const getValidation = data?.validations?.filter((item: MpowerValidationType) => item?.transactionType === "SIP" && item?.frequency === sip?.periods)[0]



    function drowDownDateFormate(array: Array<MandateListItem>) {
        return array?.map((item: MandateListItem) => {
            return {
                label: item?.displayText,
                value: item?.mandateId
            }
        })
    }

    const frequencyArray = data?.frequencies?.filter(item => item.frequency && item.transactionType === 'SIP')
    const Daily = data?.validations?.filter((item) => item?.frequency === 'DAILY' && item?.transactionType === 'SIP')?.[0]
    const Weekly = data?.validations?.filter((item) => item?.frequency === 'WEEKLY' && item?.transactionType === 'SIP')?.[0]
    const WeeklyDays = data?.validations?.filter((item) => item?.frequency === 'WEEKLYDAYS' && item?.transactionType === 'SIP')?.[0]
    const Monthly = data?.validations?.filter((item) => item?.frequency === 'MONTHLY' && item?.transactionType === 'SIP')?.[0]
    const Quarterly = data?.validations?.filter((item) => item?.frequency === 'QUARTERLY' && item?.transactionType === 'SIP')?.[0]
    const Yearly = data?.validations?.filter((item) => item?.frequency === 'YEARLY' && item?.transactionType === 'SIP')?.[0]

    const sipMinAmount = (key = 'minimumInstallmentAmount' as keyof MpowerValidationType, frequency: string) => {

        if (frequency === 'WEEKLY') {
            return Weekly?.[key]
        } else if (frequency === 'MONTHLY') {
            return Monthly?.[key]
        } else if (frequency === 'QUARTERLY') {
            return Quarterly?.[key]
        } else if (frequency === 'YEARLY') {
            return Yearly?.[key]
        } else if (frequency === 'DAILY') {
            return Daily?.[key]
        } else if (frequency === 'WEEKLYDAYS') {
            return WeeklyDays?.[key]
        } else {
            return 0
        }
    }

    const handleOpenMandateSelectDialog = () => {
        setMandateSelectDialogOpen(true)
    }

    const handleCloseMandateSelectDialog = () => {
        setMandateSelectDialogOpen(false)
    }

    const handleMandateSelection = (mandateId: string, mandateStatus: string, mandateCreationDate: string, activeMandateObj?: any) => {
        setFieldValue(`fund.${id}.sip.active`, activeMandateObj);
        setFieldValue(`fund.${id}.sip.mandate`, activeMandateObj);
        setFieldValue(`fund.${id}.sip.curMandateStatus`, "active");
        setFieldValue(`fund.${id}.sip.sipDate`, findNextValidDate(getValidation?.investmentDates ?? [], 'active', !!values?.fund?.[id]?.sip?.firstOrder, values.fund?.[id]?.sip?.periods));
        // setFieldValue(`fund[${id}].sip.firstOrder`, false);

        setMandateSelectDialogOpen(false)
    }

    const handleCreateMandateStatus = (mandateObj: any, freshMandatePayload?: any) => {
        setFieldValue(`fund.${id}.sip.active`, { mandateId: '' });
        setFieldValue(`fund.${id}.sip.active.mandateId`, "");
        setFieldValue(`fund.${id}.sip.freshMandatePayload`, freshMandatePayload);
        setFieldValue(`fund.${id}.sip.mandate`, mandateObj);
        setFieldValue(`fund.${id}.sip.pending`, mandateObj);
        setFieldValue(`fund.${id}.sip.curMandateStatus`, "pending");
        setFieldValue(`fund[${id}].sip.firstOrder`, true);
        setFieldValue(`fund.${id}.sip.sipDate`, findNextValidDate(getValidation?.investmentDates ?? [], 'pending', true, values.fund?.[id]?.sip?.periods));
    }

    const findMinimumDate = (mandateCreationDate: string | undefined, mandateStatus: string) => {
        const today = dayjs();
        if (mandateStatus?.toLowerCase() === 'active') {
            return dayjs().add(1, 'day');
        } else {
            const mandCreationDate = mandateCreationDate
                ? dayjs(mandateCreationDate)
                : dayjs();

            const mandStartDatePlus31 = mandCreationDate.add(31, 'day');
            return mandStartDatePlus31;
            // const curDatePlus30 = today.add(30, 'day');
            // if (mandCreationDate && mandCreationDate.isBefore(curDatePlus30)) {
            //     return mandCreationDate;
            // }

            // return curDatePlus30;
        }
    }

    const isMandateStatusActive = values?.fund?.[id]?.sip?.curMandateStatus === 'active';
    const findMinDate = isMandateStatusActive ? values?.fund?.[id]?.sip?.active?.startDate : values?.fund?.[id]?.sip?.pending?.startDate;


    const handleOnChange = (value: string | number) => {
        // if (values?.fund?.[id]?.sip?.curMandateStatus !== 'pending') {
        //     setFieldValue(`fund.${id}.sip.active`, {});
        //     setFieldValue(`fund.${id}.sip.mandate`, {});
        //     setFieldValue(`fund.${id}.sip.active.mandateId`, '');
        // }
        // setFieldValue(`fund.${id}.sip.sipamount`, value);
        debounce(() => {
            findMandateByAmount(Number(value), true);
        })
    }

    const findMandateByAmount = async (amount: number, croreLakhs?: boolean) => {
        try {
            setIsMandateLoading(true)
            const mandatesListRes = activeMandList.sort((a, b) => Number(a?.amount ?? 0) - Number(b?.amount))?.filter((item) => Number(item?.amount) >= Number(amount));
            setIsMandateLoading(false);
            if (mandatesListRes?.length) {
                // CORR-198: amount is intentionally '100000' as a reset/placeholder — when an active
                // mandate is found the transaction uses sip.mandate/sip.active (mandatesListRes[0]),
                // not sip.pending. curMandateStatus is set to "active" so sip.pending is not read
                // downstream. No logic change required.
                setFieldValue(`fund.${id}.sip.pending`, {
                    amount: '100000',
                    accountNo: '',
                    ifscCode: '',
                    bankName: '',
                    startDate: dayjs().format("YYYY-MM-DD"),
                    endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
                    acctType: ""
                });
                setFieldValue(`fund.${id}.sip.mandate`, mandatesListRes?.[0]);
                setFieldValue(`fund.${id}.sip.active`, mandatesListRes?.[0]);
                setFieldValue(`fund.${id}.sip.curMandateStatus`, "active");
                setFieldValue(`fund.${id}.sip.sipDate`, findNextValidDate(getValidation?.investmentDates ?? [], 'active', !!values?.fund?.[id]?.sip?.firstOrder, values.fund?.[id]?.sip?.periods));
                setActiveMandateCount(true);
            }
            else {
                setActiveMandateCount(false);
                setFieldValue(`fund.${id}.sip.pending`, {
                    amount: amount > 100000 ? amount : '100000',
                    accountNo: '',
                    ifscCode: '',
                    bankName: '',
                    startDate: dayjs().format("YYYY-MM-DD"),
                    endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
                    acctType: ""
                });
                setFieldValue(`fund.${id}.sip.mandate`,
                    {
                        mandateId: "",
                        amount: amount > 100000 ? amount : '100000',
                        accountNo: banksList?.[0]?.bankAccountNumber,
                        ifscCode: '',
                        bankName: banksList?.[0]?.bankName,
                        startDate: dayjs().format("YYYY-MM-DD"),
                        endDate: dayjs().add(40, 'year').subtract(1, 'month').format("YYYY-MM-DD"),
                        curMandateStatus: "",
                    });
                setFieldValue(`fund.${id}.sip.freshMandatePayload`, {
                    amount: amount > 100000 ? amount : '100000',
                    actype: banksList?.[0]?.bankAccountType ?? '',
                    mandateType: "N",
                    clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                    ifscCode: banksList?.[0]?.ifscCode ?? '',
                    accountNo: banksList?.[0]?.bankAccountNumber ?? '',
                    bankName: banksList?.[0]?.bankName ?? '',
                    portfolioId: selectedPortfolio?.value,
                    startDate: dayjs().format("MM/DD/YYYY"),
                    endDate: dayjs().add(40, 'year').subtract(1, 'month').format("MM/DD/YYYY"),
                });
                setFieldValue(`fund.${id}.sip.active`, {});
                setFieldValue(`fund.${id}.sip.curMandateStatus`, 'pending');
                setFieldValue(`fund.${id}.sip.sipDate`, findNextValidDate(getValidation?.investmentDates ?? [], 'pending', true, values.fund?.[id]?.sip?.periods));
                setFieldValue(`fund.${id}.sip.firstOrder`, true);
            }
            if (croreLakhs) {
                setFieldValue(`fund.${id}.sip.sipamount`, amount);
            }

        } catch (e) {
            console.error('Error in fetching data');
        }
    }

    // const handleOnBlur = async (e: React.FocusEvent<HTMLInputElement>) => {
    //     const sipAmount = Number(e.target.value);
    //     if (sipAmount >= (sipMinAmount('minimumInstallmentAmount', values?.fund[id]?.sip?.periods))) {
    //         findMandateByAmount(sipAmount, false);
    //     }
    // }

    const handleFirstOrderCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue(`fund.${id}.sip.firstOrder`, e.target.checked);
        setFieldValue(`fund.${id}.sip.sipDate`, findNextValidDate(getValidation?.investmentDates ?? [], 'active', e.target.checked, values.fund?.[id]?.sip?.periods));
    }

    const handleFrequencyChange = (event: SelectChangeEvent<any>) => {
        setFieldValue(`fund.${id}.sip.periods`, event.target.value);
        setFieldValue(`fund.${id}.sip.sipDate`, findNextValidDate(getValidation?.investmentDates ?? [], 'active', !!values?.fund?.[id]?.sip?.firstOrder, (event.target.value as Frequencytype)));
    }

    useEffect(() => {
        const fetchActiveMandates = async () => {
            try {
                const mandatesListRes = await (dispatch(getMandatesList({ amount: 0, clientCode: clientCode, status: 'Active', portfolioId: selectedPortfolio?.value ?? "" })) as unknown as Promise<MandatesListResBody>);
                setActiveMandList(mandatesListRes?.mandates ?? []);
            } catch (e) {
                console.error('Error in fetching active mandates', e);
            }
        }
        fetchActiveMandates();
    }, [])
    return (
        <>
            {(sipAllowed === 'N' || sipAllowed === null) && <>
                <Box m={'auto auto'}>
                    <Typography
                        variant="h6"
                        color={palette.error[500]}
                        sx={{ textAlign: 'center', m: 4 }}
                    >
                        SIP transaction is not allowed in this scheme
                    </Typography>
                </Box>
            </>}

            <Grid container spacing={2} rowGap={2}>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <PickUpInput
                        disabled={isSubmitting}
                        inputType="number"
                        isLoading={isLoading}
                        name={`fund[${id}].sip.sipamount`}
                        minValue={sipMinAmount('minimumInstallmentAmount', values?.fund[id]?.sip?.periods)}
                        onValueChange={(e) => handleOnChange(e)}
                        lakhCroreInput={false}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <CustomeOrangeDropDown
                        disabled={isSubmitting || isMandateLoading}
                        name={`fund[${id}].sip.periods`}
                        isLoading={isLoading}
                        label='Frequency'
                        list={[...getArrayFrequency]?.map((item: FrequencyArray) => {
                            return {
                                label: item?.frequency || '',
                                value: item?.frequency || ''
                            }
                        })}
                        onChange={handleFrequencyChange}
                    />
                </Grid>
                {(isLoading || isSubmitting) && (
                    <Box sx={{ marginLeft: 2, mt: 1, width: '100%', padding: '4px 0px 4px 15px', backgroundColor: palette.primary[200], borderRadius: 2 }}>
                        <Skeleton animation="wave" width={100} />
                    </Box>
                )}
                {(values?.fund?.[id]?.sip?.periods !== 'DAILY') && (
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomeNumberInput
                            isLoading={isLoading}
                            disable={isSubmitting || isMandateLoading}
                            textType="number"
                            label='No. of Installments'
                            name={`fund[${id}].sip.installments`}
                            minValue={sipMinAmount('minimumInstallments', values?.fund[id]?.sip?.periods)}
                            // minlabel={`Min. ${sipMinAmount('minimumInstallments', values?.fund[id]?.sip?.periods)}`}
                            removeIcons={true}
                        />
                    </Grid>
                )}
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <CustomeBlueDatePicker
                        label={values?.fund?.[id]?.sip?.periods === 'DAILY' ? "SIP Start Date" : values?.fund?.[id]?.sip?.firstOrder ? "Next SIP Date" : "SIP Date"}
                        name={`fund[${id}].sip.sipDate`}
                        isLoading={isLoading}
                        disabled={isSubmitting || isMandateLoading}
                        disablePast={isMandateStatusActive ? true : false}
                        // disableDateList={getValidation?.investmentDates}
                        shouldDisableDate={(date: dayjs.Dayjs) => handleDateValidation(getValidation?.investmentDates, date, !!values?.fund?.[id]?.sip?.firstOrder, values.fund?.[id]?.sip?.periods)}
                        // For T+2 date
                        minDate={dayjs().add(2, 'days')}
                    />
                </Grid>
                {(values?.fund?.[id]?.sip?.periods === 'DAILY') && (
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomeBlueDatePicker
                            name={`fund[${id}].sip.sipEndDate`}
                            isLoading={isLoading}
                            disablePast
                            disabled={values?.fund?.[id]?.sip.sipDate === '' || isSubmitting}
                            label="SIP End Date"
                            shouldDisableDate={(date: dayjs.Dayjs) => dayjs(date).isBefore(values?.fund?.[id]?.sip?.sipDate, 'day')}
                        />
                    </Grid>
                )}
                {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                        <MFCheckbox
                            name={`fund[${id}].sip.firstOrder`}
                            label={'First Order'}
                            disabled={isSubmitting}
                        />
                    </Grid> */}
                {(values?.fund?.[id]?.sip?.sipamount >= sipMinAmount('minimumInstallmentAmount', values?.fund[id]?.sip?.periods)) &&
                    (
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            {isMandateLoading && (
                                <Skeleton animation="wave" width={"100%"} height={80} sx={{ mt: 2 }} />
                            )}
                            {!isMandateLoading && (
                                <>
                                    <MandateInfoBox
                                        name={`fund[${id}].sip.mandate`}
                                        isLoading={isLoading}
                                        isDisabled={isSubmitting}
                                        activeMandateList={activeMandateList}
                                        id={id}
                                        activeMandateCount={activeMandateCount}
                                        isComingFromIndFund
                                    />
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: 'center',
                                            flexWrap: "wrap"
                                        }}
                                    >
                                        <Button
                                            sx={(theme: Theme) => ({
                                                ...theme.typography.body_500,
                                                color: theme.palette.primary[500],
                                                textDecoration: 'underline',
                                                padding: 0,
                                                ':hover': {
                                                    backgroundColor: "transparent"
                                                }
                                            })}
                                            onClick={handleOpenMandateSelectDialog}
                                            disabled={isSubmitting}
                                        >
                                            Select Mandate
                                        </Button>
                                    </Box>
                                </>
                            )}
                        </Grid>
                    )}
                {pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' && (
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomeOrangeDropDown
                            isLoading={isLoading}
                            disabled={isSubmitting || isMandateLoading}
                            label="Select Folio"
                            name={`fund[${id}].sip.sipFolio`}
                            list={folios?.availableFolios?.map((item) => ({ label: item, value: item }))}
                        />
                    </Grid>
                )}
                {!(isLoading || isSubmitting) && (
                    <Box sx={{ marginLeft: 2, mt: 1, width: '100%', display: 'flex', alignItems: 'center' }}>
                        <MFCheckbox
                            name={`fund[${id}].sip.firstOrder`}
                            label={'Pay 1st Installment Today'}
                            checked={!!values?.fund?.[id]?.sip?.firstOrder}
                            disabled={isSubmitting || values?.fund?.[id]?.sip?.curMandateStatus === 'pending' || isMandateLoading}
                            onChange={(e) => handleFirstOrderCheckbox(e)}
                            sx={{ mr: 0 }}
                        />
                    </Box>
                )}
            </Grid>
            {openBankModal && (
                <AddBankModal
                    {...{
                        handleClose: () => setOpenBankModal(false),
                        open: openBankModal,
                        setOpen: setOpenBankModal,
                        title: 'Add New Bank Mandate',
                        clientCode: clientCode,
                    }}
                />
            )}
            {
                isMandateSelectDialogOpen && (
                    <MandateSelectionDialog
                        open={isMandateSelectDialogOpen}
                        onClose={handleCloseMandateSelectDialog}
                        curMandateOption={curMandateOption}
                        setCurMandateOption={setCurMandateOption}
                        mandateDialogOptions={mandateDialogOptions}
                        currentMandateId={values?.fund?.[id]?.sip?.curMandateStatus === 'active' ? values?.fund?.[id]?.sip?.active?.mandateId : values?.fund?.[id]?.sip?.mandate?.mandateId ?? ""}
                        mandateList={activeMandateList}
                        handleMandateSelection={handleMandateSelection}
                        clientCode={clientCode}
                        handleCreateMandateStatus={handleCreateMandateStatus}
                        prefilledValues={values?.fund?.[id]?.sip ?? {}}
                        activeObject={values?.fund?.[id]?.sip?.active ?? {}}
                    />
                )
            }
        </>

    );
};

export default Sip